import React, { useEffect, useState, lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import firebase from 'firebase/app';
import { onAuthStateChanged } from './firebaseConfig';
import Header from './components/Header';
import Loader from './components/Loader';
import Footer from './components/Footer';
import './App.css';

const Login = lazy(() => import('./components/Login'));
const Inventory = lazy(() => import('./components/Inventory'));
const Scanner = lazy(() => import('./components/Scanner'));
const AddItem = lazy(() => import('./components/AddItem'));

export const AppContext = React.createContext(null);

function App() {
  const isSupported = 'mediaDevices' in navigator;
  const [activeUser, setActiveUser] = useState(firebase.auth().currentUser);
  const [checkedSignInStatus, setCheckedSignInState] = useState(false);

  useEffect(() => {
    // First, get the viewport height and multiply it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;

    // Then, set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const unsubscribe = onAuthStateChanged(setActiveUser, setCheckedSignInState);
    return () => {
      unsubscribe();
    };
  }, []);

  const contextValue = {
    activeUser,
    isSupported
  };

  if (checkedSignInStatus) {
    return (
      <div className="App">
        <AppContext.Provider value={contextValue}>
            <Header />
            <Suspense fallback={<Loader />}>
                <Switch>
                    <Route exact path="/" component={Inventory} />
                    <Route path="/login" component={Login} />
                    <Route path="/scan" component={Scanner} />
                    <Route path="/addItem" component={AddItem} />
                </Switch>
            </Suspense>
            <Footer />
        </AppContext.Provider>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
    </div>
  )
}

export default App;
